import { Component, OnInit, NgModule } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormsModule, FormArray } from '@angular/forms';
import { CrudService } from '../../../crud/crud.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { createAutoCorrectedDatePipe } from 'text-mask-addons';

import { Mensaje } from '../../../mensaje';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import * as moment from 'moment';


@Component({
  selector: 'app-incorporacion-financiera-alumno',
  templateUrl: './incorporacion-financiera.component.html'
})

export class IncorporacionFinancieraComponent implements OnInit{
  dato: FormGroup;
  data: FormGroup;
  periodo_escolar;

  // Mensaje
  titulo; mensaje; clase;

  grupo;
  carrera_plan;
  cargarDatosCatalogo = false;
  color = [];
  mensualidades = [];
  permisos = JSON.parse(localStorage.getItem("permisos"));

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private crud: CrudService, private notificacion: NotificationsService) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      periodos_escolares_id: ['', [Validators.required]],
      grupos_id: ['', [Validators.required]],
      grupos: this.fb.array([]),
    });

    this.data = this.fb.group({
      id: [''],
      alumnos_inicializacion: this.fb.group({
        nivel: [1],
        mes: [0],
        inicializado: [1],
        completado: [0],
        ultimo_abono: ['']
      }),
      personas_rfcs: this.fb.array([]),
      personas_cupones: this.fb.array([])
    });

    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  detalleGrupo(event, periodo) {
    this.dato.controls.grupos = this.fb.array([]);
    let id = null;
    if(event){
      if (event.hasOwnProperty("value")) {
        id = event.value;
      }else{
        id = event;
      }
    }
    if (id != "") {
      this.mensualidades = [];
      this.cargarDatosCatalogo = true;
      this.crud.ver(id + "?inicializacion=true", "grupo").subscribe(resultado => {
        this.cargarDatosCatalogo = false;
        this.grupo = resultado.data;
        this.carrera_plan = resultado.data.carreras_planes;

        this.dato.controls.periodos_escolares_id.patchValue(periodo);
        this.dato.controls.grupos_id.patchValue(id);

        for (let i = 1; i <= resultado.data.periodos_escolares.tipos_periodos.duracion_meses; i++){
          this.mensualidades.push(i);
        }
        resultado.data.grupos_alumnos.forEach(element => {

          const grupo = <FormArray>this.dato.controls.grupos;
          // SE DEBE CAMBIAR EL CAMPO matricula A LA TABLA PERSONAS
          grupo.controls.push(
            this.fb.group(
              {
                personas_id: [element.alumnos.id, [Validators.required]],
                nombre: [element.alumnos.alumnos_metadatos.apellido_paterno + ' ' + element.alumnos.alumnos_metadatos.apellido_materno + ' ' + element.alumnos.alumnos_metadatos.nombre],
                matricula: [element.alumnos.matricula],
                alumnos_inicializacion: [element.alumnos.alumnos_inicializacion.inicializado],
              }
            )
          )
        });
      },
        error => {
          this.cargarDatosCatalogo = false;
          this.titulo = "Sin resultados";
          this.mensaje = "No se encontro datos";
          this.clase = "warning";
          document.getElementById("message").click();
        }
      );
    }
  }

  guardar(id, ruta) {
    this.cargarDatosCatalogo = true;
    this.crud.editar(id, this.data.value, ruta).subscribe(
      resultado => {
        this.titulo = ruta.toUpperCase();
        this.mensaje = resultado.messages;

        if (resultado.status == 201) {
          this.clase = 'success';
        } else {
          this.clase = 'warning';
        }
        if (ruta == 'desinicializacion') {
          this.dato.controls.grupos["controls"][this.data.value.index]["controls"].alumnos_inicializacion.patchValue(0);
        } else {
          this.dato.controls.grupos["controls"][this.data.value.index]["controls"].alumnos_inicializacion.patchValue(1);
        }
        document.getElementById("message").click();

        this.color[this.data.value.id] = true;

        setTimeout(() => {
          this.color[this.data.value.id] = false;
        }, 3500);
        this.cargarDatosCatalogo = false;
        this.cancelarModal(ruta);

      },
      error => {
        const e = JSON.parse(error._body)
        this.cargarDatosCatalogo = false;
        this.titulo = ruta.toUpperCase();
        this.mensaje = e ? e.messages : 'No especificado';
        this.clase = "error";
        document.getElementById("message").click();
      }
    );
  }

  abrirModal(id, item, i) {
    this.data = this.fb.group({
      id: [item.personas_id],
      index: [i],
      alumnos_inicializacion: this.fb.group({
        nivel: [1],
        mes: [0],
        inicializado: [1],
        completado: [0],
        ultimo_abono: ['']
      }),
      personas_rfcs: this.fb.array([]),
      personas_cupones: this.fb.array([])
    });

    document.getElementById(id).classList.add('is-active');
  }

  cancelarModal(id) {
    document.getElementById(id).classList.remove('is-active');
  }
}
